module.exports = __webpack_public_path__ + "media/brands/Vendors_Dynamic_Products_1-f4c7b429.jpg";